module.exports = __webpack_public_path__ + "img/icon-11.6c361ca0.png";